import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Stack,
} from "@material-ui/core";
import { DatePicker, LoadingButton } from "@material-ui/lab";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import es from "date-fns/locale/es";
import { useRegistrarPagoEmpleadoMutation } from "src/services/facturasApi";
import { useSnackbar } from "src/components/snackbar";
import { formatearFecha } from "src/utils/formatTime";

const metodosPago = ["Transferencia", "Efectivo", "Cheque", "Otro"];

export default function RegistrarPagoModal({ open, onClose, factura }) {
  const [fechaPago, setFechaPago] = useState(new Date());
  const [monto, setMonto] = useState(factura?.total || 0);
  const [metodo, setMetodo] = useState("Transferencia");
  const [observaciones, setObservaciones] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const [registrarPago, { isLoading }] = useRegistrarPagoEmpleadoMutation();

  const handleSubmit = async () => {
    try {
      await registrarPago({
        idFactura: factura.id,
        fechaPago: formatearFecha(fechaPago, "DD/MM/YYYY"),
        montoPago: monto,
        metodoPago: metodo,
        comentario: observaciones,
      }).unwrap();

      enqueueSnackbar("Pago registrado exitosamente", { variant: "success" });
      onClose();
    } catch (error) {
      enqueueSnackbar("Error al registrar el pago", { variant: "error" });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Registrar Pago</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
            <DatePicker
              label="Fecha de pago"
              value={fechaPago}
              onChange={(newValue) => setFechaPago(newValue)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>

          <TextField
            label="Monto pagado"
            fullWidth
            type="number"
            value={monto}
            onChange={(e) => setMonto(Number(e.target.value))}
          />

          <TextField
            label="Método de pago"
            fullWidth
            select
            value={metodo}
            onChange={(e) => setMetodo(e.target.value)}
          >
            {metodosPago.map((m) => (
              <MenuItem key={m} value={m}>
                {m}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Observaciones"
            fullWidth
            multiline
            rows={3}
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <LoadingButton
          loading={isLoading}
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          Registrar Pago
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
